// Nothing a generated SDK prints may reach the person using the app: always
// log on a server (the console IS the log), only in a development build in a
// browser or on a phone.
declare const process: { env?: { NODE_ENV?: string } } | undefined;

export const SHOULD_LOG = (() => {
  const reactNativeDevFlag = (globalThis as Record<string, unknown>).__DEV__;
  if (typeof reactNativeDevFlag === "boolean") return reactNativeDevFlag;
  // Same reasoning as refreshAccessToken.ts: no bare window identifier, so
  // this compiles under a DOM lib, under React Native, and under a service's
  // ES2022-only lib alike.
  if (typeof (globalThis as { window?: unknown }).window === "undefined")
    return true;
  try {
    if (process?.env?.NODE_ENV) return process.env.NODE_ENV !== "production";
  } catch {
    // No process to ask.
  }
  return false;
})();

export const logError = (...args: unknown[]) => {
  if (SHOULD_LOG) console.error(...args);
};
export const logWarn = (...args: unknown[]) => {
  if (SHOULD_LOG) console.warn(...args);
};
export const logInfo = (...args: unknown[]) => {
  if (SHOULD_LOG) console.info(...args);
};
